import { render, staticRenderFns } from "./agentIframe.vue?vue&type=template&id=82e0b106&scoped=true&"
import script from "./agentIframe.vue?vue&type=script&lang=js&"
export * from "./agentIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e0b106",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82e0b106')) {
      api.createRecord('82e0b106', component.options)
    } else {
      api.reload('82e0b106', component.options)
    }
    module.hot.accept("./agentIframe.vue?vue&type=template&id=82e0b106&scoped=true&", function () {
      api.rerender('82e0b106', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Insurance/components/agentIframe.vue"
export default component.exports